var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chat-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.$store.state.imGroup.dialogShow,
            "custom-class": "previewDialog",
            width: "70%",
            title: _vm.$t("Message.ChatWindow"),
            "before-close": _vm.handleClose
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.$store.state.imGroup, "dialogShow", $event)
            }
          }
        },
        [
          _c("i", {
            staticClass: "el-icon-close close",
            on: { click: _vm.handleClose }
          }),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingChat,
                  expression: "loadingChat"
                }
              ],
              staticStyle: { height: "100%" },
              attrs: {
                "element-loading-text": _vm.loadingText,
                "element-loading-spinner": "el-icon-loading",
                "element-loading-background": "rgba(0, 0, 0, 0.3)"
              }
            },
            [
              _c("iframe", {
                ref: "myiframe",
                staticStyle: { border: "none", "border-radius": "10px" },
                attrs: {
                  src: _vm.imUrl,
                  scrolling: "no",
                  width: "100%",
                  height: "100%"
                }
              })
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }